import React, { FC } from 'react';

import { AgeRestriction } from '@/scenarios/legacy-player/components/PlayerSkin/parts/AgeRestriction/AgeRestriction';
import { usePlayingState } from '@/scenarios/legacy-player/hooks/usePlayingState';
import { useVideoSize } from '@/scenarios/legacy-player/hooks/useVideoSize';

interface Props {
    age: string | undefined;
    smokingWarningText?: string;
    videoWidth?: number;
    videoHeight?: number;
}

export const AgeRestrictionContainer: FC<Props> = ({
    age,
    smokingWarningText,
    videoHeight,
    videoWidth,
}) => {
    const { playingState } = usePlayingState();
    const videoSize = useVideoSize();

    if (!playingState) {
        return null;
    }

    return (
        <AgeRestriction
            age={age}
            smokingWarningText={smokingWarningText}
            videoHeight={videoHeight || videoSize?.height}
            videoWidth={videoWidth || videoSize?.width}
            playingState={playingState}
        />
    );
};
